import { Checkbox, FormControlLabel } from '@mui/material';
import { cloneDeep } from 'lodash';
import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { treeActions } from '../../../../redux/slices/treeSlice';
import { ParentScreenCtx } from '../../../../pages/workbench_build/WorkbenchBuild';
import { SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES } from '../../../../constants/constantList';

function GetDataCheckbox({selectedNode, updateData, translatedData}) {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx)
  const { templateHeader } = useSelector(state => state.treeData.workflow.rightTree.tree)
  const [donotLogWfItemDetails, setDonotLogWfItemDetails] = useState(false);
  const [runConcurrently, setRunConcurrently] = useState(false);
  const [archiveData, setArchiveData] = useState(false);
  const [disableWfItem, setDisableWfItem] = useState(false);
  const [showWfAsService, setShowWfAsService] = useState(false);
  const [enableWfAsService, setEnableWfAsService] = useState(false);
  const [enableBamConnection, setEnableBamConnection] = useState(false);
  const [isArchiveData, setIsArchiveData] = useState(true)
  const dispatch = useDispatch();
  const handleChange = (checked, setState, key) => {
    setState(checked);
    const isInvertedKey = key === 'LOG_WFITEM_DETAILS' || key === 'ENABLED';
    const booleanToString = isInvertedKey ? (checked ? 'FALSE' : 'TRUE') : (checked ? 'TRUE' : 'FALSE');

    if(key === 'ENABLED' && checked){
      setEnableWfAsService(checked);
      const tempTemplateHeader = cloneDeep(templateHeader);
      if (tempTemplateHeader?.hasOwnProperty("SERVICE")) delete tempTemplateHeader?.SERVICE;

      dispatch(treeActions.setRightTreeTemplateHeader({
        value: tempTemplateHeader,
        screen: parentScreen
      }))
      setEnableBamConnection(false);
      updateData(null, null, {[key]: booleanToString, BAM_CONN_MON_ENABLED: "FALSE"})
    } else {
      updateData(key, booleanToString);
    }
    
    if(key === 'BAM_CONN_MON_ENABLED' && !checked){
      // Remove properties dependent on 'enable workflow to be executed as service' when false
      updateData(null,null,null,{DO_NOT_PROCESS_DUPLICATE_FILES:null,ENABLE_DISTRIBUTED_FILE_PROC:null})
    }
  };


  const showEnableWfAsService = (connectionType) => {
    if (!SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES.includes(connectionType) || disableWfItem) {
      setShowWfAsService(false);
      setEnableWfAsService(false);
      return;
    }
    const oneDeepArray = translatedData?.[0]?.children || [];
    for(let i = 0;i < oneDeepArray?.length; i++) {
      const wfItem = oneDeepArray[i];
      if(wfItem?.ICON_DISPLAY === "GET_DATA") {
        if (wfItem?.key === selectedNode?.key) {
          setShowWfAsService(true);
          if (templateHeader?.SERVICE?.NAME === selectedNode?.title && templateHeader?.SERVICE?.ENABLED === "TRUE") {
            setEnableWfAsService(true);
          }
        }else {
          setShowWfAsService(false);
          setEnableWfAsService(false);
        }
        break;
      }
    }
  }

  const workflowAsServiceHandler = (checked) => {
    setEnableWfAsService(checked);
    const tempTemplateHeader = cloneDeep(templateHeader);
    if(checked) {
      tempTemplateHeader.SERVICE = {
        NAME: selectedNode?.title,
        DESCRIPTION: "BridgeGate Service",
        ENABLED: "TRUE" 
      }
    }else {
      if (tempTemplateHeader?.hasOwnProperty("SERVICE")) delete tempTemplateHeader?.SERVICE;
      handleChange(false, setEnableBamConnection, 'BAM_CONN_MON_ENABLED')
    }
    dispatch(treeActions.setRightTreeTemplateHeader({
      value: tempTemplateHeader,
      screen: parentScreen
    }))
  }

  useEffect(()=> {
    if(selectedNode){
        setDonotLogWfItemDetails(selectedNode?.LOG_WFITEM_DETAILS === 'FALSE');
        setRunConcurrently(selectedNode?.CONCURRENT === 'TRUE');
        setArchiveData(selectedNode?.ARCHIVE_TRANSACTION_FILES === 'TRUE');
        setDisableWfItem(selectedNode?.ENABLED === 'FALSE');
        setEnableBamConnection(selectedNode?.BAM_CONN_MON_ENABLED === 'TRUE')
      }
  },[selectedNode?.key, selectedNode?.ARCHIVE_TRANSACTION_FILES]) 
  //included selectedNode?.ARCHIVE_TRANSACTION_FILES to update the checkbox when the value changes from the WorkflowProperties control
    
  useEffect(() => {
    if(selectedNode?.INBOUND?.ADAPTER_TYPE) {
      showEnableWfAsService(selectedNode?.INBOUND?.ADAPTER_TYPE);
    }
  },[selectedNode?.INBOUND?.ADAPTER_TYPE, disableWfItem])

  useEffect(() => {
    const adapter = selectedNode?.INBOUND?.ADAPTER_TYPE
    if(adapter === 'DATABASE'){
      setIsArchiveData(false)
    } else {
      setIsArchiveData(true)
    }
  },[selectedNode?.INBOUND?.ADAPTER_TYPE])

  return (
    <div>
      <FormControlLabel
        label={t('LBL_LOG_NO_WFITEM_DETAILS')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        control={
          <Checkbox 
           checked={donotLogWfItemDetails}
           size='small' 
           name='donotLogWfItemDetails'
           onChange={(e, checked) => handleChange(checked, setDonotLogWfItemDetails,'LOG_WFITEM_DETAILS')} />
        }
      />
        <FormControlLabel
        label={t('LBL_RUN_CONCURRENTLY')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        control={
          <Checkbox 
           checked={runConcurrently}
           size='small' 
           name='runConcurrently'
           onChange={(e, checked) => handleChange(checked, setRunConcurrently, 'CONCURRENT')} />
        }
      />
      {isArchiveData && (
        <FormControlLabel
        label={t('LBL_ARCHIVE_DATA')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        control={
          <Checkbox 
           checked={archiveData}
           size='small' 
           name='archiveData'
           onChange={(e, checked) => handleChange(checked, setArchiveData, 'ARCHIVE_TRANSACTION_FILES')} />
        }
        />
       )}
        <FormControlLabel
        label={t('LBL_DISABLE_WFITEM')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        control={
          <Checkbox 
           checked={disableWfItem}
           size='small' 
           name='disableWfItem'
           onChange={(e, checked) => {
              // if(checked) setTimeout(() => {
              //   workflowAsServiceHandler(false)
              // })
              handleChange(checked, setDisableWfItem, 'ENABLED')
          }} />
        }
      />
      { showWfAsService && <FormControlLabel
        label={t('ENABLE_WORKFLOW_AS_SERVICE')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        disabled={disableWfItem}
        control={
          <Checkbox 
           checked={enableWfAsService}
           size='small' 
           name='enableWfAsService'
           onChange={(e, checked) => {
            workflowAsServiceHandler(checked)
          }} />
        }
      />}
       {selectedNode?.INBOUND?.ADAPTER_TYPE === 'BridgeGateSocket' && enableWfAsService && (<FormControlLabel
        label={t('BAM_ENABLE_CONN_MON')}
        sx={{height: '30px'}}
        className={'width-fit-content'}
        control={
          <Checkbox 
           checked={enableBamConnection}
           size='small' 
           name='enableBam'
           onChange={(e, checked) => handleChange(checked, setEnableBamConnection, 'BAM_CONN_MON_ENABLED')} />
        }
      />)}
    </div>
  );
}

export default GetDataCheckbox